import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { initializeApp } from 'firebase/app';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSFirestore, OrderBy, Where } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { element } from 'protractor';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import firebase from 'firebase/compat/app'; 


initializeApp(environment.firebaseConfig);

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'] // Correction de l'erreur de typo
})
export class NotificationsComponent implements OnInit , OnDestroy{
  notifications: any[] = [];
  unreadCount: number = 0;
  isNotificationPanelOpen = false;
  isOptionsMenuOpen = false;
  auth = new FirebaseTSAuth();

  
  
  constructor( private router: Router, private eRef: ElementRef) {}

  ngOnInit() {
    this.loadNotifications();
    document.addEventListener('click', this.onClickOutside.bind(this), true);
  }

   // Retirer l'écouteur pour éviter les fuites de mémoire
   ngOnDestroy() {
    document.removeEventListener('click', this.onClickOutside.bind(this), true);
  }

  // Fonction pour détecter si le clic s'est produit en dehors du panneau de notifications
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    
    // Vérifie si le clic est en dehors du panneau de notifications
    if (this.isNotificationPanelOpen && !this.eRef.nativeElement.contains(target)) {
      this.isNotificationPanelOpen = false;
    }
    
    // Ferme le menu d'options si le clic est en dehors
    if (this.isOptionsMenuOpen && !target.closest('.mobile-options')) {
      this.isOptionsMenuOpen = false;
    }
  }

  toggleOptionsMenu(event: Event) {
    event.stopPropagation(); // Empêche la propagation du clic
    this.isOptionsMenuOpen = !this.isOptionsMenuOpen;
  }

  loadNotifications() {
    const firestore = new FirebaseTSFirestore();
    const currentUserId = this.auth.getAuth().currentUser.uid;

    firestore.listenToCollection({
      name: "NotificationsListener",
      path: ["Notifications"],
      where: [
        new Where("recipientUserId", "==", currentUserId),
      ],
      onUpdate: (result) => {
        this.notifications = result.docs.map(doc => {
          let data = doc.data();
          let timestamp = data['timestamp'];
          timestamp = timestamp ? new Date(timestamp) : new Date(0);

          return {
            id: doc.id,
            ...data,
            timestamp: timestamp,
            commentId: doc.data().commentId || null,
            postImageUrl: '',
            senderProfileImageUrl: '',
            postType: '', 
            agribox: data.agribox || undefined
          };
        })
        .filter(notification => notification.agribox === undefined);

        // Récupérer les détails pour chaque notification
        this.notifications.forEach(notification => {
          if (notification.interactionType === 'aimé' || notification.interactionType === 'commenté') {
            // Récupérer les détails du post
            this.getPostDetails(notification.postId).then(postDetails => {
              if (postDetails.videoUrl) {
                notification.postType = 'video';
                notification.postImageUrl = 'assets/video-thumbnail.png';
              } else if (postDetails.imageUrl) {
                notification.postType = 'image';
                notification.postImageUrl = postDetails.imageUrl;
              } else {
                notification.postType = 'text';
                notification.postImageUrl = 'assets/text-thumbnail.png'; // Image par défaut pour les publications texte
              }
            });

            // Récupérer l'image de profil
            this.getUserProfileImage(notification.senderUserId).then(profileImageUrl => {
              notification.senderProfileImageUrl = profileImageUrl;
            });
          }
        });

        // Mettre à jour le compteur de notifications non lues
        this.unreadCount = this.notifications.filter(notification => !notification.isRead).length;

        this.notifications.sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
      }
    });
  }

  getPostDetails(postId: string): Promise<any> {
    return new Promise((resolve) => {
      const firestore = new FirebaseTSFirestore();
      firestore.getDocument({
        path: ["Posts", postId],
        onComplete: (result) => {
          if (result.exists) {
            resolve(result.data());
          } else {
            resolve({});
          }
        }
      });
    });
  }

  getPostImage(postId: string): Promise<string> {
    return new Promise((resolve) => {
      const firestore = new FirebaseTSFirestore();
      firestore.getDocument({
        path: ["Posts", postId],
        onComplete: (result) => {
          if (result.exists) {
            const post = result.data();
            if (post.imageUrl) {
              resolve(post.imageUrl);
            } else if (post.videoUrl) {
              // Image par défaut pour les vidéos
              resolve('assets/video-thumbnail.png');
            } else {
              resolve('');
            }
          } else {
            resolve('');
          }
        }
      });
    });
  }

  // Fonction pour récupérer l'image de profil via le senderUserId
  async getUserProfileImage(userId: string): Promise<string> {
    const doc = await firebase.firestore().collection('Users').doc(userId).get();
      
     return doc.data()?.profilePhotoUrl || '';
  }


  // Marquer une notification comme lue
  markAsRead(notificationId: string) {
    const firestore = new FirebaseTSFirestore();
    
    firestore.update({
      path: ["Notifications", notificationId],
      data: { isRead: true },
      onComplete: () => {
        this.loadNotifications();  // Recharger les notifications après mise à jour
      }
    });
  }

  async onNotificationClick(notification: any) {
    // Marquer la notification comme lue
    const firestore = new FirebaseTSFirestore();
    await firestore.update({
      path: ["Notifications", notification.id],
      data: { isRead: true }
    });

    // Mettre à jour le statut local de la notification
    notification.isRead = true;
    this.unreadCount = this.notifications.filter(n => !n.isRead).length;

    // Fermer le panneau de notifications
    this.isNotificationPanelOpen = false;

    // Navigation vers la publication
    if (notification.postId) {

      if (notification.commentId) {
      
       
         // Force la navigation même si on est déjà sur la même URL
        this.router.navigateByUrl('/postfeed', {skipLocationChange: true}).then(() => {
          this.router.navigate(['/postfeed/post', notification.postId], {
            queryParams: { showComments: true, commentId: notification.commentId }
          });
        });
      } else {
           // Force la navigation même si on est déjà sur la même URL
          this.router.navigateByUrl('/postfeed', {skipLocationChange: true}).then(() => {
            this.router.navigate(['/postfeed/post', notification.postId]);
          });
        }
     
    }
  }

  toggleNotificationPanel() {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
  }

  hasUnreadNotifications(): boolean {
    return this.notifications.some(notification => !notification.isRead);
  }

  markAllAsRead() {
    const firestore = new FirebaseTSFirestore();
    const currentUserId = this.auth.getAuth().currentUser.uid;

    // Mettre à jour toutes les notifications non lues
    this.notifications
      .filter(notification => !notification.isRead)
      .forEach(notification => {
        firestore.update({
          path: ["Notifications", notification.id],
          data: { isRead: true }
        });
      });

    // Mettre à jour l'état local
    this.notifications.forEach(notification => {
      notification.isRead = true;
    });
    this.unreadCount = 0;
  }

  formatDate(timestamp: string): string {
    const notificationDate = new Date(timestamp);
    const currentDate = new Date();
    
    // Calcul de la différence en millisecondes entre la date actuelle et la date de la notification
    const diffMs = currentDate.getTime() - notificationDate.getTime();
  
    // Conversion des millisecondes en minutes, heures, jours, semaines, mois et années
    const diffMinutes = Math.floor(diffMs / (1000 * 60)); // Différence en minutes
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60)); // Différence en heures
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // Différence en jours
    const diffWeeks = Math.floor(diffDays / 7); // Différence en semaines
    const diffMonths = Math.floor(diffDays / 30); // Différence en mois approximatif
    const diffYears = Math.floor(diffDays / 365); // Différence en années approximatif
  
    // Logique pour afficher le temps écoulé
    if (diffMinutes < 1) {
      return `à l'instant`;
    } else if (diffMinutes < 60) {
      return `il y a ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
    } else if (diffHours < 24) {
      return `il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
    } else if (diffDays < 7) {
      return `il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
    } else if (diffWeeks < 4) {
      return `il y a ${diffWeeks} semaine${diffWeeks > 1 ? 's' : ''}`;
    } else if (diffMonths < 12) {
      return `il y a ${diffMonths} mois`;
    } else {
      return `il y a ${diffYears} an${diffYears > 1 ? 's' : ''}`;
    }
  }
}
